import { type ChangeEvent, useEffect } from 'react';

import { css, styled } from '@mui/material';

import { CheckboxItem } from '../CheckboxItem';
import { useSectionMessageContext } from './SectionMessageContext';
import { sectionMessageCheckboxClasses } from './theme';

import type { SectionMessageCheckboxOwnerState, SectionMessageCheckboxProps } from './types';

const SectionMessageCheckbox = (props: SectionMessageCheckboxProps) => {
  const { onChange, defaultChecked, checked, ...others } = props;

  const ownerState: SectionMessageCheckboxOwnerState = {
    ...props,
  };

  const { setCheckboxChecked, checkboxChecked } = useSectionMessageContext();

  useEffect(() => {
    const isCheckedPropsExists = checked !== undefined;
    const isDefaultCheckedExists = defaultChecked !== undefined;

    if (setCheckboxChecked) {
      const initialValue = isCheckedPropsExists
        ? checked
        : isDefaultCheckedExists
          ? defaultChecked
          : false;

      setCheckboxChecked(initialValue);
    }
  }, [defaultChecked, checked, setCheckboxChecked]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    // Context의 체크박스 상태 직접 업데이트
    if (setCheckboxChecked) {
      setCheckboxChecked(checked);
    }

    // 원래 onChange 핸들러 호출
    if (onChange) {
      onChange(event, checked);
    }
  };

  return (
    <SectionMessageCheckboxWrapper ownerState={ownerState}>
      <CheckboxItem {...others} checked={checkboxChecked} onChange={handleChange} />
    </SectionMessageCheckboxWrapper>
  );
};

export default SectionMessageCheckbox;

// Styled Components
const SectionMessageCheckboxWrapper = styled('div', {
  target: sectionMessageCheckboxClasses.root,
})<{ ownerState: SectionMessageCheckboxProps }>(
  () => css`
    margin-top: 4px;
  `,
);
